import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["component", "hasAccess", "redirectTo"],
  _excluded2 = ["component", "requirement"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import useAppContext from 'flow/hooks/useAppContext';
import { allowCtiCommunication } from 'flow/selectors/cti-integration-selectors';
import { routes } from 'flow/types/routes';
import { isEmbeddedTypeCti } from 'flow/utils/app-utils';
import { IS_UAE_HOST } from 'flow/utils/browser-utils-TW';
import { hasCtiSettings } from 'flow/utils/cti-settings-utils';
import React from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import { Route, Redirect, useParams, generatePath } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
var PrivateRoute = function PrivateRoute(_ref) {
  var Component = _ref.component,
    hasAccess = _ref.hasAccess,
    redirectTo = _ref.redirectTo,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(Route, _objectSpread(_objectSpread({}, rest), {}, {
    render: function render(props) {
      return hasAccess ? /*#__PURE__*/_jsx(Component, _objectSpread({}, props)) : /*#__PURE__*/_jsx(Redirect, {
        to: redirectTo
      });
    }
  }));
};
export var PrivateSettingsRoute = function PrivateSettingsRoute(_ref2) {
  var Component = _ref2.component,
    requirement = _ref2.requirement,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  var _useAppContext = useAppContext(),
    embedded = _useAppContext.embedded;
  var _useParams = useParams(),
    extensionKey = _useParams.extensionKey;
  var ctiSettingExist = useAppSelector(function (state) {
    return allowCtiCommunication(state) ? hasCtiSettings(state) : false;
  });
  var retailerId = useAppSelector(function (state) {
    var _state$customer;
    return (_state$customer = state.customer) === null || _state$customer === void 0 ? void 0 : _state$customer.getIn([extensionKey, 'retailer', 'key']);
  });
  var dashboard = useAppSelector(function (state) {
    return state.wallboards.get('hasAccess');
  });

  // Hide for Etisalat and Rainbow users
  var mobile = !IS_UAE_HOST && !['retailer-1211'].includes(retailerId);
  var cti = isEmbeddedTypeCti(embedded) && ctiSettingExist;
  var hasAccessTo = function hasAccessTo(requirement) {
    var requirements = {
      dashboard: dashboard,
      mobile: mobile,
      cti: cti
    };
    return !!requirements[requirement];
  };
  return /*#__PURE__*/_jsx(Route, _objectSpread(_objectSpread({}, rest), {}, {
    render: function render(props) {
      return /*#__PURE__*/_jsx(PrivateRoute, _objectSpread({
        component: Component,
        redirectTo: generatePath(routes['settings.account'], {
          extensionKey: extensionKey
        }),
        hasAccess: hasAccessTo(requirement)
      }, props));
    }
  }));
};